import React, { useState } from 'react';
import { ClockFormatSelector } from '../ClockFormatSelector';

interface HeaderProps {
  is24hFormat: boolean;
  onClockFormatChange: () => void;
}

const Header: React.FC<HeaderProps> = ({ is24hFormat, onClockFormatChange }) => {
  const [showAboutModal, setShowAboutModal] = useState(false);

  return (
    <>
      <div className="row mb-5">
        <div className="col">
          <h4 className="grey-title">
            time.rsh.co{' '}
            <button
              className="btn btn-link text-muted p-0"
              style={{ fontSize: '0.8rem', verticalAlign: 'super' }}
              onClick={() => setShowAboutModal(true)}
            >
              (?)
            </button>
          </h4>
        </div>
        <div className="col">
          <span style={{ float: 'right' }}>
            <ClockFormatSelector is24hFormat={is24hFormat} onClockFormatChange={onClockFormatChange} />
          </span>
        </div>
      </div>

      {showAboutModal && (
        <div className="modal show d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">About</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={() => setShowAboutModal(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  This website saves it settings in your browser's local storage.
                </p>
                <p>
                  This website was made by <a href="https://www.rayhan.com/">Rayhan</a> with love.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowAboutModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
